import { HttpClient } from "@angular/common/http";
import { NGXLogger } from "ngx-logger";
import { Injectable } from "@angular/core";

@Injectable()
export class BillerDashboardService {

  constructor(private http: HttpClient,
    private logger: NGXLogger) { }
  getBillerTxnsView(viewBillerTxn): any {
    //this.logger.debug("calling get api from BillerTransaction .....");
    return this.http.post('/honcho/api/dashboard/biller/txns-graph-data/view', viewBillerTxn, { observe: 'response' });
  }
  getBillerTxnsReportDataView(viewBillerTxnsReportObj): any {
    //this.logger.debug("calling get api from getBillerTxnsReportDataView.....");
    return this.http.post('/honcho/api/dashboard/biller/txns-dashboard-report/view', viewBillerTxnsReportObj, { observe: 'response' });
  }
  getBillerKeyPerformanceIndicator(obj): any {
    //this.logger.debug("calling get api from AdminDashBoardService.....");
    return this.http.post('/honcho/api/dashboard/biller/key-performance-indicator/view', obj, { observe: 'response' });
  }
  getBillerRecentTransaction(tabularObj): any {
    //this.logger.debug("calling get api from getBillerRecentTransaction.....");
    return this.http.post('/honcho/api/dashboard/biller/recent-transactions/view', tabularObj, { observe: 'response' });
  }
  getBillerTxnsAmountView(viewBillerTxnAmnt): any {
    //this.logger.debug("calling get api from BillerTransaction .....");
    return this.http.post('/honcho/api/dashboard/biller/datewise-txns-amount/view', viewBillerTxnAmnt, { observe: 'response' });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/biller-dashboard/biller-dashboard.service.ts